var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 442 512.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.52.13 12.07 35.58C5.46 36.56 0 43.4 0 50.19v418.56c0 6.75 5.39 9.37 12.07 10.29l237.45 32.95c6.67.92 12.06-7.76 12.06-14.62V10.43c0-6.86-5.53-11.27-12.06-10.3zm37.66 458.26h31.01v-93.28l25.34 13.54V459c0 6.76-2.79 12.94-7.26 17.43-4.47 4.51-10.67 7.3-17.48 7.3h-31.61v-25.34zm93.13-276.02v34.04c.58-.17 1.19-.27 1.81-.27h53.43c3.48 0 6.45 2.97 6.45 6.45v66.14c0 3.49-2.9 6.45-6.45 6.45h-53.43c-.62 0-1.24-.09-1.81-.26v34.03c-.04 2.87-1.12 5.75-3.3 7.96-4.39 4.46-11.58 4.52-16.05.13l-76.89-75.53c-4.27-4.59-4.01-11.78.58-16.05l75.95-70.84a11.3 11.3 0 0 1 8.32-3.63c6.29 0 11.39 5.1 11.39 11.38zm-62.12-36.15V52.94h-31.01V27.6h31.61c6.81 0 13 2.79 17.48 7.26 4.47 4.47 7.26 10.67 7.26 17.47v80.35l-25.34 13.54zm-87.61 78.39-24.91-5.67v74.18l24.91-7.18v-61.33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.b4e2dce98e151948f3ac434206b5542d.svg";
export { ForwardRef as ReactComponent };